import { message } from 'antd';
import { useState } from 'react';
import { customInstance } from '@/shared/api/mutator/custom-instance';
import { HrAccountMapping } from '../types';

export function useHrAccountMapping() {
  const [mappings, setMappings] = useState<HrAccountMapping[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchMappings = async () => {
    setLoading(true);
    try {
      const data = await customInstance<HrAccountMapping[]>({ url: '/api/hr/account-mappings', method: 'GET' });
      setMappings(data);
      return data;
    } catch {
      message.error('Failed to load account mappings');
      return [];
    } finally {
      setLoading(false);
    }
  };

  const saveMapping = async (dto: Partial<HrAccountMapping>) => {
    try {
      const data = await customInstance<HrAccountMapping>({ url: '/api/hr/account-mappings', method: 'POST', data: dto });
      message.success('Account mapping saved');
      await fetchMappings();
      return data;
    } catch {
      message.error('Failed to save account mapping');
    }
  };

  const deleteMapping = async (id: number) => {
    try {
      await customInstance({ url: `/api/hr/account-mappings/${id}`, method: 'DELETE' });
      message.success('Account mapping deleted');
      await fetchMappings();
    } catch {
      message.error('Failed to delete account mapping');
    }
  };

  return { mappings, loading, fetchMappings, saveMapping, deleteMapping };
}
